import * as layout from '../../../components/markLayout.module.css';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
const IrreversibleWarning: React.FC = () => (
    <div
        role="alert"
        style={{
            backgroundColor: 'var(--mark-danger-surface)',
            marginBottom: '1.6rem',
            color: 'var(--mark-danger)'
        }}
        className={layout.notice}
    >
        <P noDefaultMargin strong>
            Name, message class, and delivery scope cannot be changed after creation. Review these
            choices carefully. Variants remain editable while the blast is a draft.
        </P>
    </div>
);
export default IrreversibleWarning;
